import { Instance, types } from 'mobx-state-tree';
import { withSetPropAction } from 'src/models/extensions/withSetPropAction';
import { OperatorInfo } from 'src/models/operator-info/OperatorInfo';

// 데이터 모드: 텍스트 속성
const TextAttribute = types.model('TextAttribute').props({
  text: types.maybeNull(types.string),
  color: types.maybeNull(types.string),
});

// 데이터 모드
const DataContent = types.model('DataModeData').props({
  mainText: types.maybeNull(TextAttribute),
  subText: types.maybeNull(TextAttribute),
  bgPath: types.maybeNull(types.array(types.string)),
});

// 각 에디터의 컨텐츠와 스타일 데이터
const EditorContent = types.model('EditorData').props({
  shapes: types.optional(types.array(types.frozen()), []),
  assets: types.optional(types.array(types.frozen()), []),
});

// 에디터 모드: 디바이스별 데이터
const DeviceEditorData = types.model('DeviceEditorData').props({
  desktop: types.optional(EditorContent, {}),
  tablet: types.optional(EditorContent, {}),
  mobile: types.optional(EditorContent, {}),
});

// 메인 비주얼 모델
export const MainVisual = types
  .model('MainVisual')
  .props({
    mode: types.string,
    visualSid: types.number,
    useYn: types.maybeNull(types.boolean),
    delYn: types.maybeNull(types.boolean),
    ordr: types.maybeNull(types.number),
    lang: types.maybeNull(types.string),
    regUser: types.maybeNull(OperatorInfo),
    updUser: types.maybeNull(OperatorInfo),
    regDt: types.optional(types.maybeNull(types.number), 0),
    updDt: types.optional(types.maybeNull(types.number), 0),
    // 에디터 모드 컨텐츠
    editorContent: types.optional(DeviceEditorData, {}),
    // 데이터 모드 컨텐츠
    mainText: types.optional(TextAttribute, {}),
    subText: types.optional(TextAttribute, {}),
    bgPath: types.optional(types.array(types.string), []),
  })
  .volatile(() => ({
    files: [] as File[],
    deleteFilesPath: [] as string[],
  }))
  .actions(withSetPropAction);

// 타입 정의
type TMainVisual = Instance<typeof MainVisual>;
type TTextAttribute = Instance<typeof TextAttribute>;
type TDataContent = Instance<typeof DataContent>;
type TEditorContent = Instance<typeof EditorContent>;
type TDeviceEditorData = Instance<typeof DeviceEditorData>;

// 인터페이스 export
export interface IMainVisual extends TMainVisual {}
export interface ITextAttribute extends TTextAttribute {}
export interface IDataContent extends TDataContent {}
export interface IEditorContent extends TEditorContent {}
export interface IDeviceEditorData extends TDeviceEditorData {}

export const createMainVisual = () =>
  types.optional(MainVisual, {
    mode: 'data',
    visualSid: 0,
    useYn: null,
    delYn: null,
    ordr: null,
    lang: null,
    regUser: null,
    updUser: null,
    regDt: null,
    updDt: null,
    mainText: { text: '', color: '#000' },
    subText: { text: '', color: '#000' },
    bgPath: [],
    editorContent: {
      desktop: {
        shapes: [],
        assets: [],
      },
      tablet: {
        shapes: [],
        assets: [],
      },
      mobile: {
        shapes: [],
        assets: [],
      },
    },
  });
